import { Directive, Input, ViewChild } from '@angular/core';
import { DynamicTypeaheadCategoryBaseComponent } from '@ups/xplat/dynamic-render';
import { DropDownListComponent } from '@progress/kendo-angular-dropdowns';
import { passMultiSelectValueChange } from './dynamic-typeahead-view-binding';

@Directive()
export abstract class DynamicTypeaheadCategoryWebBaseComponent extends DynamicTypeaheadCategoryBaseComponent {
  @ViewChild('dropdown') dropdown: DropDownListComponent;
  /** Tabindex to propagate to the underlying kendo dropdown */
  @Input({ transform: parseInt }) tabindex: number;

  /** A kendo-multiselect's (valueChange) hands its whole selection (see passMultiSelectValueChange). */
  multiSelectValueChange(items: Parameters<this['valueChangeItem']>[0][]) {
    passMultiSelectValueChange(this, items);
  }

  setValue(value: unknown) {
    if (this.dropdown) {
      this.dropdown.value = value;
    }
  }
}
